import { Component, OnInit, OnDestroy, ViewChild, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material/dialog";

import { MatTable } from "@angular/material/table";
import { PickerItem } from '../../models/picker-item.model';
import { Observable } from 'rxjs';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { debounceTime, switchMap } from 'rxjs/operators';
import { MaxPickerService } from '../../services/max-picker.service';
import { RoleService } from '../../services/role.service';
import { RoleGroupMember } from '../../models/role-group-member.model';
import { SiteLevelRoleMember } from '../../models/site-level-role-member.model';
import { ConfirmationDialogComponent, ConfirmationDialogModel } from '../../dialogs/confirmation/confirmation-dialog.component';
//import { FolderService } from '../../services/folder.service';
import { AccessibilityHelper } from '../../accessibility.helper';
import { Role } from '../../models/role.model';
import { DrawerComponentBase } from '../../components/drawer-component-base/drawer-component-base.component';
import { IDrawerComponentLiaison } from '../../interfaces/idrawer-component-liaison';
import { FolderPermissionService } from '../../services/folder-permission.service';
import { CurrentSiteService } from '../../services/current-site.service'; 

// Note:  this compponent resides in the dialogs subdirectory as much of its logic is derived from role-membership.dialog.ts,
//        part of a component that will be retired once we switch over completely to the new permissions model.
@Component({
    selector: 'app-role-membership-drawer',
    templateUrl: './role-membership-drawer.component.html',
    styleUrls: ['./role-membership-drawer.component.scss'],
    standalone: false
})
export class RoleMembershipDrawerComponent extends DrawerComponentBase implements OnInit, OnDestroy {
    // Input(s).
    @Input() role: Role = null;
    @Input() drawerComponentLiaison: IDrawerComponentLiaison = null;

    // Properties.
    private members: SiteLevelRoleMember[];
    //private dirty: boolean;
    private membersCreatedOrDeleted: boolean = false;
    private displayedColumns: string[]
    private addMemberForm: UntypedFormGroup;
    private showLoadingIndicator: boolean = false;
    private pickerItems: Observable<PickerItem[]>;
    private formControls: any = {
        id: -1,
        user: [{}]
    };
    //private allMembers: RoleMember[];
    private roleId: number;
    private folderId: number;
    private pickerLoadingTmeoutId: any = null;

    @ViewChild('roleMemberTable')
    roleMemberTable: MatTable<SiteLevelRoleMember>;

    // Constructor.
    public constructor(private roleService: RoleService,
        private folderPermissionService: FolderPermissionService,
        private currentSiteService: CurrentSiteService,
        private fb: UntypedFormBuilder,
        private maxPickerService: MaxPickerService,
        private dialog: MatDialog) {
        super();
    }

    // Life cycle methods.
    public ngOnInit(): void {
        super.ngOnInit(); // Important to call this as the first line in this method.

        // Note:  the following lines of code were pulled from the RoleMembershipDialog constructor.
        this.members = null; // this.filterInheritedMembers(this.role.members, false);
        this.folderPermissionService.getSiteLevelRoleMembers(this.role.id).then(roleMembers => {
            this.members = roleMembers;
        });

        // Note:  the following code was pulled from RoleMembershipDialog.ngOnInit().
        this.addMemberForm = this.fb.group(this.formControls);
        this.initializeFilteredUsers();
        this.initializeLoadingIndicator();
        this.displayedColumns = ['name', 'actions'];    // pharv 9/20/21 uncomment this to renable different behaviors at Site vs Folder level:
    }

    public ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    // Define/implement methods called by my HTML code.
    public get Title(): string {
        return `${this.role.name} Members`
    }

    public get Members(): SiteLevelRoleMember[] {
        return this.members;
    }

    public set Dirty(value: boolean) {
        //this.dirty = value;
        this.membersCreatedOrDeleted = true;
    }

    public get DisplayedColumns(): string[] {
        return this.displayedColumns;
    }

    public get AddMemberForm(): UntypedFormGroup {
        return this.addMemberForm;
    }

    public get ShowLoadingIndicator(): boolean {
        return this.showLoadingIndicator;
    }

    public DisplayUserName(pi: PickerItem): string {
        return pi.displayName;
    }

    public get PickerItems(): Observable<PickerItem[]> {
        return this.pickerItems;
    }

    // Handle control events.
    public deleteMember(event: any, member: SiteLevelRoleMember): void {
        /*
        let func = () => {
            this.roleService.deleteMember(member.id, this.folderId).then(() => {
                this.members.splice(this.members.findIndex(x => x.id == member.id), 1);
                this.roleMemberTable.renderRows();
                this.membersCreatedOrDeleted = true;
            });
        }

        //if (this.isSiteLevel()) {
        //    this.deleteOnConfirm(1, func);
        //} else {
        func();
        //}
        */
        member.roleName = this.role.name;
        this.folderPermissionService.deleteSiteLevelRoleMember(this.currentSiteService.Site.id, member).then(response => {
            //this.members.splice(this.members.findIndex(x => x.id == member.id), 1);
            this.members = this.members.filter(m => m.id != response.id);
            this.role.siteLevelRoleMembers = this.role.siteLevelRoleMembers.filter(m => m.id != response.id);
            this.roleMemberTable.renderRows();
            this.membersCreatedOrDeleted = true;
        });
    }

    public deleteAllMembers(): void {
        let iDs = this.members.map(x => { return x.id });

        this.deleteOnConfirm(this.members.length, () => {
            this.roleService.deleteAllRoleMembers(this.roleId, this.folderId).then(() => { });
            // no need to wait for the call to return
            this.members = [];
            this.roleMemberTable.renderRows();
            this.membersCreatedOrDeleted = true;
        });
    }

    public addMember(): void {
        let rm = new RoleGroupMember(this.addMemberForm.value.user.key, this.addMemberForm.value.user.isUser);
        let siteLevelRoleMember = new SiteLevelRoleMember(rm, this.role);
        rm.roleName = this.role.name;

        this.addMemberForm.reset(this.formControls);

        if (rm.member == undefined) {
            //console.log('added member is not defined');
            return;
        }

        /*
        let memberFound = this.allMembers.filter(m => { return m.memberId == this.addMemberForm.value.user.key })[0];
        if (memberFound != null) {
            memberFound.selected = true;
            this.members.push(memberFound);
            this.roleMemberTable.renderRows();
            this.dirty = true;
            //this.addMemberForm.reset(this.formControls);
            this.membersCreatedOrDeleted = true;
            AccessibilityHelper.setFocus('#add-role-member-input');
            return;
        }
        */

        //prevent adding duplicate members
        let newUser = true;
        if (this.role.members != null) {
            let siteLevelMembers: SiteLevelRoleMember[] = this.role.siteLevelRoleMembers; //.getMembersAsSiteLevelMembers();
            for (let index: number = 0; index < siteLevelMembers?.length; index++) {
                //let existingRoleMember: RoleGroupMember = this.role.members[index];
                let existingRoleMember: SiteLevelRoleMember = siteLevelMembers[index];
                if (existingRoleMember.member == rm.member) {
                    newUser = false;
                    break;
                }
            }
        }
        
        if (newUser) {
            /*
            this.roleService.addMember(this.role.id, this.folderId, rm).then(member => {
                //member.selected = true; // needed to avoid a weird bug
                this.members.push(member);
                this.roleMemberTable.renderRows();
                //this.dirty = true;
                this.membersCreatedOrDeleted = true;
                AccessibilityHelper.setFocus('#add-role-member-input');
            });
            */
            this.folderPermissionService.addSiteLevelRoleMember(this.currentSiteService.Site.id, siteLevelRoleMember).then(member => {
                this.members.push(member);
                if (!this.role.siteLevelRoleMembers) {
                    this.role.siteLevelRoleMembers = [];
                }
                this.role.siteLevelRoleMembers.push(member);
                this.roleMemberTable.renderRows();
                this.membersCreatedOrDeleted = true;
                AccessibilityHelper.setFocus('#add-role-member-input');
            });
        }
    }

    // Helper methods.
    private initializeFilteredUsers(): void {
        this.pickerItems = this.addMemberForm.controls['user'].valueChanges.pipe(
            debounceTime(300),                                          // swallow multiple valueChanges made within 300ms period and just keep the most recent one
            switchMap(value => this.maxPickerService.search(value)) // switch to a new observable, canceling the previous
        );
    }

    private initializeLoadingIndicator(): void {
        this.maxPickerService.isSearching.subscribe((value) => {
            if (value) {
                if (!this.showLoadingIndicator) {
                    this.pickerLoadingTmeoutId = setTimeout(() => { this.showLoadingIndicator = true }, 450);
                }
            }
            else {
                clearTimeout(this.pickerLoadingTmeoutId);
                this.showLoadingIndicator = false;
            }
        });
    }

    /*
    private filterInheritedMembers(members: SiteLevelRoleMember[], membersAreInherited: boolean): SiteLevelRoleMember[] {
        let filteredMembers = members;
        if (membersAreInherited) {
            filteredMembers = members.filter(m => { return !m.isInherited });
        }

        //if (this.role.memberCount() > 0) {
        //return filteredMembers.filter(m => { return m.selected });
        //} else {
        //    return filteredMembers;
        //}

        return members;
    }
    */

    // Seems like this and other similar blocks could be factored into something reusable
    // Things that would need to be passed:
    // - this.dialog
    // - "Remove Member from Role"
    // - "Are you sure you want to remove this member? The operation cannot be undone."
    private deleteOnConfirm(numToDelete: number, callback: Function): void {
        let title = numToDelete == 1 ? `Remove Member from Role` : 'Remove Members from Role';
        let message = numToDelete == 1 ?
            `Are you sure you want to remove this member? The operation cannot be undone.` :
            `Are you sure you want to remove all members? This operation cannot be undone.`
        let dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            maxWidth: "400px",
            data: new ConfirmationDialogModel(title, message)
        });
        dialogRef.afterClosed().subscribe(yes => {
            if (yes) callback();
            AccessibilityHelper.setFocus('#add-role-member-input');
        });
    }
}
